import { Methods } from '@api/entry/subscribe'
import { Request } from '../../request'
export default async (query:Methods["get"]["query"]) => Request( client => client.entry.subscribe.$get({query}) )
